import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DialogManager, EventService } from 'proxiponents';
import AuctionDocumentDialog from './auction-document-dialog';
import { SHOW_AUCTION_DOC_DIALOG } from './auction-document-events';
import DescriptionIcon from '@material-ui/icons/Description';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Link,
  makeStyles,
} from '@material-ui/core/';

AuctionDocument.propTypes = {
  docsData: PropTypes.array.isRequired,
  pluginMode: PropTypes.string.isRequired,
};

const useStyles = makeStyles({
  icon: {
    minWidth: '30px',
  },
  displayName: {
    flex: '0 1 auto',
    '&:hover': {
      cursor: 'pointer'
    },
  }
});

function AuctionDocument({ docsData, pluginMode }) {
  const classes = useStyles();
  const [docUrl, setDocUrl] = useState('https://wavebid.com/auctionDocument.html');
  const [guid, setGuid] = useState('');
  const [displayName, setDisplayName] = useState('');

  useEffect(() => {
    if (pluginMode === 'test') {
      setDocUrl('https://demowww.wavebid.com/auctionDocument.html');
    }
  });

  const handleDocClick = (e, docData) => {
    if (docData.visibility < 10000) {
      e.preventDefault();

      setGuid(docData.guid);
      setDisplayName(docData.displayName);
      EventService.dispatchEvent(SHOW_AUCTION_DOC_DIALOG);
    }

    return null;
  };

  return (
    <Fragment>
      <List>
        {docsData.map(doc => (
          <ListItem key={doc.guid}>
            <ListItemIcon classes={{ root: classes.icon }}>
              <DescriptionIcon />
            </ListItemIcon>
            <Link
              href={`${docUrl}?documentGuid=${doc.guid}&action=get-document`}
              target="_blank"
              rel="noopener"
              onClick={e => handleDocClick(e, doc)}
            >
              <ListItemText
                classes={{ root: classes.displayName }}
                primary={doc.displayName}
              />
            </Link>
          </ListItem>
        ))}
      </List>
      <DialogManager
        title="Your email address is required to view this document:"
        event={SHOW_AUCTION_DOC_DIALOG}
        message={
          <AuctionDocumentDialog
            guid={guid}
            displayName={displayName}
            pluginMode={pluginMode}
          />
        }
        onClose={() => {}}
      />
    </Fragment>
  );
}

export default AuctionDocument;